// Core Imports
import * as React from 'react';
import { canViewInvoices } from 'src/utils/permissions';

// Style, Media and  Misc imports
import './EmptyStatement.scss';
import emptyInvoiceImage from 'src/assets/emptyInvoicesImage';
import Loader from 'src/components/common/Loader';
import env from 'src/shared/env';

const EmptyInvoices = (props: any) => {
  const { t } = props;
  switch (props.type) {
    case 'loading':
      return (
        <div className="rp-empty-statement">
          <Loader />
        </div>
      );
    default:
    case 'noResults':
      return (
        <div className="rp-empty-statement">
          <img src={emptyInvoiceImage} alt="" />
          <h1>
            {canViewInvoices()
              ? `${t('accountMonthlyStatements.noMonthlyStatementTxt')}`
              : `${t('accountMonthlyStatements.noAccessToInvoiceTxt')}`}
          </h1>
          <p>{t('invoices.appreciateBusiness')}</p>
          <p style={{ color: 'red', maxWidth: '400px', marginTop: '16px' }}>
            {t('accountMonthlyStatements.statementsWillBePopulated')}{' '}
            {env.REACT_APP_BASE_ENVIRONMENT === 'US'
              ? 'December 31, 2019 '
              : 'July 31, 2020 '}
            {t('accountMonthlyStatements.forwardAccountReceivableTxt')}
            {env.REACT_APP_BASE_ENVIRONMENT === 'US'
              ? ' 1-800-841-4060.'
              : ' 1-866-985-5301.'}
          </p>
        </div>
      );
    case 'noSearch':
      return (
        <div className="rp-empty-statement">
          <img src={emptyInvoiceImage} alt="" />
          <h1>{t('common.noResultsFound')}</h1>
          <p>{t('invoices.noInvoicesTryAgain')}</p>
        </div>
      );
  }
};

export default EmptyInvoices;
